module.exports = __webpack_public_path__ + "static/Chimera-4732a2cc7b5257ba0a6d4d0b09778989.jpg";